module.exports = "../assets/not_available.19815946.jpg";